import Auth from './auth.js';
export default class Models {
    constructor() {
        // this.url = (sessionStorage.getItem('kiplan_api_url') ?? 'https://internal.kiplan.io/api') + '/modeleditor';
        // this.headers = {
        //     'Content-Type': 'application/json',
        //     'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
        // }     
        this.auth = new Auth();
        this.url = '/modeleditor';
    }

    async fetch(...args) {
        return await this.auth.fetch(...args);
    }

    encode(query) {

        return Object.keys(query).map(key => {
            // if query[key] is object, stringify it
            if (typeof query[key] === 'object') {
                return key + '=' + JSON.stringify(query[key])
            } else {
                return key + '=' + query[key]
            }
        }).join('&');
    }

    async getModels(query) {
        const response = await this.fetch(`${this.url}/models/?${this.encode(query)}`, {
            method: 'GET',
        });
        if (response.status != 200) {
            console.log(response)
        }
        return await response.json();
    }

    async getDimensions(query) {
        const response = await this.fetch(`${this.url}/dimensions/?${this.encode(query)}`, {
            method: 'GET',
            headers: this.headers
        });
        if (response.status != 200) {
            console.log(response)
        }
        return await response.json();
    }

    async getProperties(query) {
        const response = await this.fetch(`${this.url}/properties/?${this.encode(query)}`, {
            method: 'GET',
            headers: this.headers
        });
        if (response.status != 200) {
            console.log(response)
        }
        return await response.json();
    }

    async saveModel(model) {
        console.log("POST MODEL")
        const response = await this.fetch(`${this.url}/model/`, {
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Saving Model ${model.name}. STATUS ${response.status}. \n ${detail}.`)
        }
        return await response.json();
    }

    async saveDimension(modelId, dimension) {
        console.log("POST DIMENSION", dimension)
        const response = await this.fetch(`${this.url}/dimension/${modelId}`, {
            method: 'POST',
            body: JSON.stringify(dimension)
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Saving Dimension ${dimension.name}. STATUS ${response.status}. \n ${detail}.`)
            return detail
        }
        return response.json();
    }

    async saveProperty(property) {
        console.log("POST PROPERTY", property)
        const response = await this.fetch(`${this.url}/property/`, {
            method: 'POST',
            body: JSON.stringify(property)
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error saving property ${property.name}. STATUS ${response.status}. \n Output ${detail}`)
        }
        return await response.json();
    }

    async saveProperties(properties) {
        console.log("POST PROPERTIES", properties)
        const response = await this.fetch(`${this.url}/properties/`, {
            method: 'POST',
            body: JSON.stringify(properties)
        });
        if (response.status != 200) {
            // const detail = JSON.stringify(await response.json())
            // alert(`RELOAD PAGE. \n Error saving properties STATUS`)
        }
        return response;
    }

    async deleteModel(id) {
        console.log("DELETE MODEL", id)
        const response = await this.fetch(`${this.url}/model/${id}`, {
            method: 'DELETE',
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Deleting Model ${id}. STATUS ${response.status}. \n ${detail}.`)
        }
        return await response.json();
    }

    async deleteDimension(id) {
        console.log("DELETE DIMENSION", id)
        const response = await this.fetch(`${this.url}/dimension/${id}`, {
            method: 'DELETE',
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Deleting Dimension ${id}. STATUS ${response.status}. \n ${detail}.`)
        }
        return await response.json();
    }

    async deleteProperty(id) {
        console.log("DELETE PROPETY", id)
        const response = await this.fetch(`${this.url}/property/${id}`, {
            method: 'DELETE',
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Deleting property ${id}. STATUS ${response.status}. \n ${detail}.`)
        }
        return await response.json();
    }

    async getDimensionData(dimension_id, params) {
        `
            Params:
            columns: list of columns / None returns all
            where
            order_by
            limit
            offset
        `
        const response = await this.fetch(`${this.url}/dimension/data/${dimension_id}/?${this.encode(params)}`, {
            method: 'GET',
            headers: this.headers
        });
        if (response.status != 200) {
            alert(await response.json())
        }
        return response
    }
    async saveDimensionData(dimension_id, rows){
        const response = await this.fetch(`${this.url}/dimension/data/${dimension_id}/`, {
            method: 'POST',
            body: JSON.stringify(rows)
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Saving Dimension Data. STATUS ${response.status}.\n Detail ${detail}`)
        }
        return await response.json()
    }
    async deleteDimensionData(dimension_id, ids){
        const response = await this.fetch(`${this.url}/dimension/data/${dimension_id}/`, {
            method: 'DELETE',
            body: JSON.stringify(ids)
        });
        if (response.status != 200) {
            alert(`RELOAD PAGE. \n Error Deleting Dimension Data. STATUS ${response.status}.`)
        }
        return response
    }

    async addModelDimension(model_id, dimension_id) {
        const response = await this.fetch(`${this.url}/modeldimension/${model_id}/${dimension_id}`, {
            method: 'POST',
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Adding Dimension to Model. STATUS ${response.status}.\n Detail ${detail}`)
        }
        return await response.json();
    }

    async deleteModelDimension(dimension_id, model_id) {
        console.log("DELETE MODEL DIMENSION", dimension_id, model_id)
        const response = await this.fetch(`${this.url}/modeldimension/${model_id}/${dimension_id}/`, {
            method: 'DELETE',
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Deleting Model Dimension ${dimension_id}. STATUS ${response.status}. \n ${detail}.`)
        }
        return await response.json();
    }
    
    async getModelUsersAndUsers(model_id) {
        const response = await this.fetch(`${this.url}/modeluser/${model_id}/`, {
            method: 'GET',
        });
        return response;
    }

    async createModelUser(user_id, model_id, read, write) {
        const response = await this.fetch(`${this.url}/modeluser/`, {
            method: 'POST',
            body: JSON.stringify({user_id, model_id, read, write})
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Saving Model User. STATUS ${response.status}. \n ${detail}.`)
        }
        return await response.json();
    }


    async deleteModelUser(model_id, user_id) {
        const response = await this.fetch(`${this.url}/modeluser/${model_id}/${user_id}/`, {
            method: 'DELETE',
        });
        if (response.status != 200) {
            const detail = JSON.stringify(await response.json())
            alert(`RELOAD PAGE. \n Error Deleting Model User. STATUS ${response.status}. \n ${detail}.`)
        }
        return await response.json();
    }

    async dataFormset(dimension_id, rows) {
        const response = await this.fetch(`${this.url}/dimension/dataformset/${dimension_id}`, {
            method: 'POST',
            body: JSON.stringify(rows.filter(row => row._delete || row._update || row._create))
        });
        return response
    }

    async getHierarchies(model_id) {
        const response = await this.fetch(`${this.url}/hierarchies/${model_id}/`, {
            method: 'GET',
        });
        return response;
    }

    async postHierarchyFormset(hierarchies) {
        const response = await this.fetch(`${this.url}/hierarchies/`, {
            method: 'POST',
            body: JSON.stringify(hierarchies)
        });
        return response;
    }

    async deleteHierarchy(hierarchy_id) {
        const response = await this.fetch(`${this.url}/hierarchies/${hierarchy_id}/`, {
            method: 'DELETE',
        });
        return response;
    }

    async modelUserFormset(modelUsers) {
        console.log('UPDATING')
        const response = await this.fetch(`${this.url}/modeluser/formset`, {
            method: 'POST',
            body:  JSON.stringify(modelUsers)
        });
        return response;
    }

    async killBlocking() {
        const response = await this.fetch(`${this.url}/kill_blocking/`, {
            method: 'POST',
        });
        return await response.json();
    }
    
}
